import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import localeEnGB from '@angular/common/locales/en-GB';
import localeSv from '@angular/common/locales/sv';
import localeNb from '@angular/common/locales/nb';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private static readonly DEFAULT_LOCALE = 'en-GB';
  public static LOCALE = LocaleService.DEFAULT_LOCALE;

  private static readonly LOCALE_ALIASES: Record<string, string> = {
    se: 'sv',
    no: 'nb',
    da: 'da',
    en: 'en-GB'
  };

  constructor(@Inject(LOCALE_ID) private localeId: string) {
    // Registrer alle locale data ved opstart
    registerLocaleData(localeDa);
    registerLocaleData(localeEnGB);
    registerLocaleData(localeSv);
    registerLocaleData(localeNb);
  }

  get userLocale(): string {
    let userLocale = navigator.languages ? navigator.languages[0] : navigator.language;
    if (userLocale !== 'en-US') {
      userLocale = LocaleService.DEFAULT_LOCALE;
    }
    LocaleService.LOCALE = userLocale;
    return userLocale;
  }

  setLocale(locale: string): void {
    const normalizedLocale = LocaleService.normalizeLocale(locale);
    LocaleService.LOCALE = normalizedLocale;
    localStorage.setItem('userLocale', normalizedLocale);
    //For at ændringer slår igennem, skal siden genindlæses
    window.location.reload();
  }

  static getSavedLocale(): string {
    let language = localStorage.getItem('userLocale') || LocaleService.DEFAULT_LOCALE;
    language = LocaleService.normalizeLocale(language);
    return language;
  }

  private static normalizeLocale(locale: string): string {
    const languageCode = locale.split('-')[0].toLowerCase();
    return LocaleService.LOCALE_ALIASES[languageCode] || languageCode;
  }
}
